let itm = {
  // bcg: require('../bcg_unit.png'),
  bcg2: require('./u8.png'),
  name: 'I’m wild',
  items: [],
};

export default itm;
